import index from './index.vue';
import { TransferData, AllWorkData } from './all.type';

export default index;
export {
    AllWorkData,
    TransferData
};